import { render } from "./MyAdBannersView.vue?vue&type=template&id=98334172&scoped=true"
import script from "./MyAdBannersView.vue?vue&type=script&lang=js"
export * from "./MyAdBannersView.vue?vue&type=script&lang=js"

import "./MyAdBannersView.vue?vue&type=style&index=0&id=98334172&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98334172"]])

export default __exports__